export default function AdsJingles() {

  return (
    <div className='AdsJingles'>
      <div>
        <p>Nagrade najbolji jingle prema ocjenivačkom sudu Hrvatske udruge radija i novina:</p>
        <ul>
          <li>
            <span>
              <a href="https://radiomegaton.hr/wp-content/uploads/2020/06/CRVENKAPICA-I-VUK-JINGLE.mp3" target="_blank" rel="noreferrer">
                “Crvenkapica”
                </a> – 11. Dani radija Hrvatske 2005., 02.06.2005.
                </span>
          </li>
          <li>
            <a href="https://radiomegaton.hr/wp-content/uploads/2020/06/FU-WEI-JINGLE-ZAGORSKI.mp3" target="_blank" rel="noreferrer">
              “Fu Wei jingle zagorski”
              </a>
              – 1. Dani elektroničkih medija 2008. 24.10.2008., 14. Dani radija. 1. Dani televizije, 1. Dani interneta
              </li>
          <li>
            <a href="https://radiomegaton.hr/wp-content/uploads/2020/06/BAKA-MARIJA-PRE-60.mp3" target="_blank" rel="noreferrer">
              “Baka Marija pre 60”</a>– 5. Dani elektroničkih medija 13.-15.12.2012.
                  </li>
          <li>
            <a href="https://radiomegaton.hr/wp-content/uploads/2020/06/JINGLE-NE-PILI.mp3" target="_blank" rel="noreferrer">
              “Ne pili”</a>– 9. Dani elektroničkih medija, 22. Dani radija, Opatija 22.-24.11.2016.
              </li>
          <li>
            <a href="https://radiomegaton.hr/wp-content/uploads/2020/06/JINGLE-KAMERA-TON-MEGATON.mp3" target="_blank" rel="noreferrer">
              “Kamera, ton, Megaton”
                  </a>– 11. Dani elektroničkih medija, Sveti Martin na Muri, 13.-15.11.2018.
                  </li>
        </ul>
      </div>
      <div><p>Nagrade HURINA najbolja akcija:</p>
        <ul>
          <li><span><b>“Deset dana Megatona”&nbsp;</b>– 5. Dani elektroničkih medija, Opatija, 13.-15.12.2012.</span></li>
          <li><b>“Biranje MEGAčelnika”&nbsp;</b>– 6. Dani elektroničkih medija, Opatija, 28.-30.11.2013.</li>
          <li><b>“Biciklom do zdravlja”&nbsp;</b>– 7. Dani elektroničkih medija, Opatija 21.-23.10.2014.</li>
        </ul></div>
      <div>
        <p>Nagrada Hurina najbolja internet stranica:</p>
        <ul>
          <li>
            <span>Dani elektroničkih medija 2008. – 24.10.2008., 14. Dani radija. 1. Dani televizije, 1. Dani interneta</span>
          </li>
        </ul>
        <div>&nbsp;</div></div>
    </div>
  );
}